/**
 * Check if a given string has a chemical equation in it.
 * @param mathEquation
 */
export function hasChemicalEquation(mathEquation: string) {
  const matches = mathEquation.match(/\\ce\s*{/);
  return matches?.length > 0;
}
